/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeleteCallsByIds200Response
 */
export interface DeleteCallsByIds200Response {
    /**
     * 
     * @type {boolean}
     * @memberof DeleteCallsByIds200Response
     */
    deleted?: boolean;
}

/**
 * Check if a given object implements the DeleteCallsByIds200Response interface.
 */
export function instanceOfDeleteCallsByIds200Response(value: object): value is DeleteCallsByIds200Response {
    return true;
}

export function DeleteCallsByIds200ResponseFromJSON(json: any): DeleteCallsByIds200Response {
    return DeleteCallsByIds200ResponseFromJSONTyped(json, false);
}

export function DeleteCallsByIds200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteCallsByIds200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'deleted': json['deleted'] == null ? undefined : json['deleted'],
    };
}

export function DeleteCallsByIds200ResponseToJSON(json: any): DeleteCallsByIds200Response {
    return DeleteCallsByIds200ResponseToJSONTyped(json, false);
}

export function DeleteCallsByIds200ResponseToJSONTyped(value?: DeleteCallsByIds200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'deleted': value['deleted'],
    };
}

